// eslint-disable-next-line max-len
export default "<svg data-name=\"icon/wiki_help\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path data-name=\"Path 303\" d=\"M10 0a10 10 0 1 0 10 10A10 10 0 0 0 10 0Zm1 15H9V9h2Zm0-8H9V5h2Z\" fill=\"#414141\"/></svg>";
